// Blog post
// Move related-articles to the end of main
document.addEventListener('DOMContentLoaded', () => {
  const related = document.querySelector('related-articles');
  const main = document.querySelector('main');

  if (related && main) {
    const wrapper = document.createElement('section');
    wrapper.className = 'article';

    wrapper.appendChild(related);

    main.appendChild(wrapper);
  }
});